import { MapPinIcon } from "@heroicons/react/24/outline";
import { parsePhoneNumber } from "awesome-phonenumber";
import slugify from "slugify";
import { type RoamdocJobPost } from "#/db/schema";

export default function JobLocation({
  posting,
}: {
  posting: RoamdocJobPost;
}) {
  if (!posting.schema) return null;
  const { jobLocation } = posting.schema;
  const facility = posting.facility;

  const facilityName = facility?.name;
  const streetAddress =
    facility?.streetAddress ?? jobLocation?.address.streetAddress;
  const city = facility?.cityName ?? jobLocation?.address.addressLocality;
  const state = facility?.stateId ?? jobLocation?.address.addressRegion;
  const postalCode = facility?.postalCode ?? jobLocation?.address.postalCode;
  const phone = parsePhoneNumber(facility?.phone ?? "", { regionCode: "US" })
    .number?.national;

  const mapsImageSlug = slugify(`${facilityName}-${state}`, { lower: true });
  const mapsImageUrl = `/healthcare-job-search/images/${mapsImageSlug}-maps-place-${facility?.id}.webp`;

  return (
    <div className="mt-16">
      <h3 className="mb-1 flex items-center text-sm font-normal text-gray-400">
        <MapPinIcon className="h-6 w-6" />
        Job Location
      </h3>
      <h4 className="mb-2 font-bold">{facilityName}</h4>

      <address className="not-italic">
        <p>{streetAddress}</p>
        <p>
          {city}, {state} {postalCode}
        </p>
        <p className="mt-1 text-sm text-gray-400">{phone}</p>
      </address>

      {facility && (
        <div className="mt-8">
          <img className="rounded" src={mapsImageUrl} alt={facilityName ?? ""} />
        </div>
      )}
    </div>
  );
}
